import React from 'react';
import { Field } from 'react-final-form';
import css from './CustomExtendedDataField.module.css'; // Update with your actual CSS path
import FieldMultiSelect from '../FieldMultiSelect/FieldMultiSelect';
import { createMultiFilterOptions } from './CustomExtendedDataField';
import { getAgencies } from '../../containers/AuthenticationPage/AuthenticationPage.duck';
import { useSelector } from 'react-redux';

const AgencySelect = ({ name, validate, values, formId, intl }) => {
  const CUSTOM = 'custom';
  const agencies = useSelector(getAgencies);
  const customOption = { option: CUSTOM, label: 'Custom Agency' };
  const enhancedOptions = [...agencies, customOption];
  const { pub_agency } = values || {};

  return (
    <div className={css.agencySelectWrapper}>
      <Field
        component={FieldMultiSelect}
        isMulti={false}
        id={formId ? `${formId}.${name}` : name}
        name={name}
        label={intl.formatMessage({
          id: 'AgencySelect.agencyLabel',
        })}
        options={createMultiFilterOptions(enhancedOptions)}
        {...validate}
      />
      {pub_agency?.value === CUSTOM && (
        <Field name={`${name}_custom`} validate={validate}>
          {({ input, meta }) => (
            <div>
              <input
                {...input}
                type="text"
                className={css.textInput}
                placeholder="Enter custom agency name"
              />
              {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
            </div>
          )}
        </Field>
      )}
    </div>
  );
};

export default AgencySelect;
